export default [
  {
    path: '/slideshow',
    name: 'slideshow',
    component: () => import('@/views/menu/slideshow/slideshow.vue'),
    meta: {
      pageTitle: 'مدیریت اسلایدشو',
      action: 'show',
      resource: 'SlideshowManager',
    },
  },
  {
    path: '/slideshow/details',
    name: 'addslideshow',
    component: () => import('@/views/menu/slideshow/slideshowdetails.vue'),
    meta: {
      pageTitle: 'ایجاد اسلایدشو',
      action: 'show',
      resource: 'SlideshowManager',
    },
  },
  {
    path: '/slideshow/details/:id',
    name: 'updateslideshow',
    component: () => import('@/views/menu/slideshow/slideshowdetails.vue'),
    meta: {
      pageTitle: 'ویرایش اسلایدشو',
      action: 'show',
      resource: 'SlideshowManager',
    },
  },
  {
    path: '/division',
    name: 'division',
    component: () => import('@/views/menu/slideshow/division.vue'),
    meta: {
      pageTitle: 'مدیریت نوع کالاها',
      action: 'show',
      resource: 'DivisionManager',
    },
  },
  {
    path: '/style',
    name: 'style',
    component: () => import('@/views/menu/slideshow/style.vue'),
    meta: {
      pageTitle: 'مدیریت سبک ها',
      action: 'show',
      resource: 'StyleManager',
    },
  },
  {
    path: '/budget',
    name: 'budget',
    component: () => import('@/views/menu/slideshow/budget.vue'),
    meta: {
      pageTitle: 'مدیریت بودجه ها',
      action: 'show',
      resource: 'BudgetManager',
    },
  },
]
